import React from "react";
import { BnbLabel } from "../../../utils/labels";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/lexus/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/lexus/globals/Modal";
import type { FinanceCalculatorModalType } from "../../../utils/modalConstants";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";

const FinanceCalculatorModal = (props: ModalViewType<FinanceCalculatorModalType>): JSX.Element => {
    const { show, modalSettings } = props;
    const { title, containerID, resetCalculator } = modalSettings;

    // We don't use props.close since there can also be external events which hide the modal, so the handling is delegated to the resetCalculator function.
    return (
        <ModalBaseView
            modalIdType={modalSettings.type}
            onClose={resetCalculator}
            show={show}
            size="lg"
            /* the tor-* classNames are specific for the Finance Calculator injection
            and should not be reused anywhere else, or-* classnames are for billboard/salesman */
            contentClass="tor-modal-content or-modal-content modal-body"
            disableOutsideClick
            focusTrap={false}
        >
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label={title} />
                </Modal.Title>
                <Modal.Button onClick={resetCalculator}>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body noSpacing>
                <div id={containerID} style={{ minHeight: "350px" }} />
            </Modal.Body>
        </ModalBaseView>
    );
};

export default FinanceCalculatorModal;
